<div class="feedback-version-uploader" *ngIf="status != SHARE_ERROR">
    <ng-container *ngIf="status == DONE else sharemessageloading">
        <ng-container *ngIf="versionShare.status.status_code == UPLOAD_STATUS.OPENED_CODE else alreadyuploaded">
        <!-- <ng-container *ngIf="uploadVersion.upload.version == null else alreadyuploaded"> -->
            <div class="artwork-upload-box-action upload-artwork">
                <div class="action-message"><span>Please upload New Artwork Version</span>
                    <figure class="action-icon  upload-artwork-ico"></figure>
                </div>
            </div>
            <article class="artwork-upload-box-message" >
                <core-helper-box-header-user-date [date]="versionShare.status.date" [user]="versionShare.entry.user">
                </core-helper-box-header-user-date>
                <div class="content">
                    <div class="message-text" [innerHTML]="message"></div>
                </div>
                
            </article>
            <fieldset *ngIf="actionButton" class="but_width">
                <core-helpers-forms-button-white [text]="'UPLOAD ARTWORK FILES'" (click)="onOpenUpload($event)">
                </core-helpers-forms-button-white>
            </fieldset>
        </ng-container>
        <ng-template #alreadyuploaded>
            <div class="artwork-upload-box-action approved-artwork">
                <div class="action-message"><span>You uploaded a New Version on {{versionShare.status.date | date: 'dd MMM yyyy'}}</span>
                    <figure class="action-icon approve-ico"></figure>
                </div>
            </div>
        </ng-template>
    </ng-container>

    <ng-template #sharemessageloading>
        <div class="loader">
            <div class="dimmed">
                <div class="dimmed_box_message"></div>
            </div>
        </div>
    </ng-template>
</div>